// UserReportsController.js
import { useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import WindowedSelect from "react-windowed-select";
import { fetchTargetAchievementReport, fetchCollectionsReport, fetchPendingDispatchReport, fetchOutstandingReport, fetchSalesReport, fetchStockLevelReport, fetchUserParties } from "Service/ApiService";

const UserReportsController = () => {
 // const navigate = useNavigate();
  const rawUser = localStorage.getItem("user");
  const user = rawUser ? JSON.parse(rawUser) : null;
  //console.log("User from localStorage:", user);
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState(null);

  // const [parties, setParties] = useState({});
  // const [selectedParty, setSelectedParty] = useState({});
  const [parties, setParties] = useState([]);        // ✅ array
const [selectedParty, setSelectedParty] = useState(null); // ✅ null


  // Reports Data
  const [targetAchievementReportData, setTargetAchievementReportData] = useState({});
  const [collectionsReportData, setCollectionsReportData] = useState({});
  const [pendingDispatchReportData, setPendingDispatchReportData] = useState({});
  const [outstandingReportData, setOutstandingReportData] = useState({});
  const [salesReportData, setSalesReportData] = useState({});
  const [stockLevelReportData, setStockLevelReportData] = useState({});

  const [salesChartTypes, setSalesChartType] = useState();
  const [selectedSalesChartType, setSelectedSalesChartType] = useState({});

  useEffect(() => {
    setSalesChartType([{ value: "division", label: "By Division" }, { value: "category", label: "By Category" }]);
  }, []);

 
  useEffect(() => {
    getUserParties();
  }, []);

  // useEffect(() => {
  //   if (!user?.userCodeList || !Array.isArray(user.userCodeList)) {
  //     setParties([]);
  //     setSelectedParty(null);
  //     return;
  //   }

  //   const dropdownData = user.userCodeList.map((item) => ({
  //     value: item.userCode,
  //     label: `${item.displayName || "Unknown"} - ${item.userCode}`,
  //   }));

  //   setParties(dropdownData);
  //   setSelectedParty(dropdownData[0] || null);
  //   console.log('parties', parties);
  // }, []);

useEffect(() => {
  if (!userType) return;

  // PRI → wait for parties
  if (userType === "PRI" && parties.length === 0) return;

  // SEC → wait for selectedParty
  if (userType === "SEC" && !selectedParty?.value) return;

  getTargetAchievementReport();
  getCollectionsReport();
  getPendingDispatchReport();
  getOutstandingReport();
  getSalesReport();
  getStockLevelReport();

}, [userType, parties, selectedParty]);

  // const goTo = (route, extra = {}) => {
  //   navigate(route, { state: { selectedDate, ...extra } });
  // };

  const getUserParties = async () => {
    try {
      const res = await fetchUserParties(user.userCode);
      if (res && res.success) {
        setUserType(res.user_type);
        const dropdownData = res.partyCodes.map((item) => ({
          value: item.partyCode,
          label: `${item.partyName || "Unknown"} - ${item.partyCode}`,
        }));
        setParties(dropdownData);
        // SEC → select first party only
        if (res.user_type === "PRI") {
          setSelectedParty(dropdownData[0] || null);
        }

        // PRI → no single selection needed
        if (res.user_type === "SEC") {
          setSelectedParty(null);
        }
      } else {
        setParties([]);
        setSelectedParty(null);
      }
    } catch (err) {
      console.error("User Parties load error:", err);
      setParties([]);
      setSelectedParty(null);
    }
  };

const getPartyCodeForAPI = () => {
  if (userType === "SEC" && Array.isArray(parties) && parties.length > 0) {
    return parties.map(p => p.value).join(",");
  }

  if (userType === "PRI" && selectedParty?.value) {
    return selectedParty.value;
  }

  return null;
};


  const getSalesReport = async () => {
    setLoading(true);
    try {
      const partyCode = getPartyCodeForAPI();
   console.log(partyCode,'---partyCode')
      if (!partyCode) {
        setSalesReportData({});
        return;
      }
      const res = await fetchSalesReport(partyCode);
     console.log('sales Report',res.data);
      if (res && res.success) {
        setSalesReportData(res.data);
      } else {
        setSalesReportData({});
      }
    } catch (err) {
      console.error("User Sales Reports load error:", err);
    } finally {
      setLoading(false);
    }
  };


  // Get target vs achievement report data
  const getTargetAchievementReport = async () => {
    setLoading(true);
    try {
      const res = await fetchTargetAchievementReport(selectedParty.value || user.userCode);
      // console.log('res target--->>',res.data);
      //const res = await fetchTargetAchievementReport(1000);
      if (res && res.success) {
        setTargetAchievementReportData(res.data);
      } else {
        setTargetAchievementReportData({});
      }
    } catch (err) {
      console.error("User Target vs Acheievement Reports load error:", err);
    } finally {
      setLoading(false);
    }
  }

  // Get collections report data
  const getCollectionsReport = async () => {
    setLoading(true);
    try {
      const res = await fetchCollectionsReport(selectedParty.value || user.userCode);
      // const res = await fetchCollectionsReport(1500);
      if (res && res.success) {
        setCollectionsReportData(res.data);
      } else {
        setCollectionsReportData({});
      }
    } catch (err) {
      console.error("User Collections Reports load error:", err);
    } finally {
      setLoading(false);
    }
  }

  // Get pending vs dispatch report data
  const getPendingDispatchReport = async () => {
    setLoading(true);
    try {
      const res = await fetchPendingDispatchReport(selectedParty.value || user.userCode);
      // const res = await fetchPendingDispatchReport(1000);
      if (res && res.success) {
        setPendingDispatchReportData(res.data);
      } else {
        setPendingDispatchReportData({});
      }
    } catch (err) {
      console.error("User Pending vs Dispatch Reports load error:", err);
    } finally {
      setLoading(false);
    }
  }

  // Get outstanding report data
  const getOutstandingReport = async () => {
    setLoading(true);
    try {
      const res = await fetchOutstandingReport(selectedParty.value || user.userCode);
      // const res = await fetchOutstandingReport(1000);
      if (res && res.success) {
        setOutstandingReportData(res.data);
      } else {
        setOutstandingReportData({});
      }
    } catch (err) {
      console.error("User outstanding Reports load error:", err);
    } finally {
      setLoading(false);
    }
  }

  // Get stock level report data
  const getStockLevelReport = async () => {
    setLoading(true);
    try {
      const res = await fetchStockLevelReport(selectedParty.value || user.userCode);
      //const res = await fetchSalesReport(1000);
      // console.log('stock response',res.data);
      if (res && res.success) {
        setStockLevelReportData(res.data);
      } else {
        setStockLevelReportData({});
      }
    } catch (err) {
      console.error("Stock level Reports load error:", err);
    } finally {
      setLoading(false);
    }
  }


  return {
    loading,
    // selectedDate,
    // setSelectedDate,
    // goTo,
   // reload: () => load(selectedDate),

    parties,
    selectedParty,
    setSelectedParty,

    // Reports Data
    targetAchievementReportData,
    collectionsReportData,
    pendingDispatchReportData,
    outstandingReportData,
    salesReportData,
    stockLevelReportData,

    // Virtualized Select Component
    VirtualizedPartySelect: (
      <WindowedSelect
        options={parties}
        value={selectedParty}
        onChange={(value) => setSelectedParty(value)}
        placeholder="Select Sales Officer"
        isSearchable
        windowThreshold={50}
        maxHeight={300}
      />
    ),

    salesChartTypes,
    selectedSalesChartType,
    setSelectedSalesChartType,
  };
};

export default UserReportsController;
